 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Cover Note
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryCNFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryCNFilterForm"
                            v-model="filtersCoverNote.coverNoteNo"
                            :label="filtersCoverNoteLabel.coverNoteNo"
                            :error-messages="errors.collect('coverNoteNo')"
                            data-vv-name="coverNoteNo"
                            :data-vv-as="filtersCoverNoteLabel.coverNoteNo"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearCoverNoteFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doCoverNoteFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="coverNoteHeaders"
          :items="coverNoteItems"
          v-bind:options.sync="paginationCoverNote"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsCoverNote"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.cnNo }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignCoverNote(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      showCoverNoteHelpList: false,
      filtersCoverNoteLabel: {
        coverNoteNo: 'Cover Note No.'
      },
      filtersCoverNote: {
        coverNoteNo: undefined
      },
      coverNoteItems: [],
      totalItemsCoverNote: 0,
      coverNoteHeaders: [
        { text: 'Cover Note.', align: 'left', value: 'cnNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationCoverNote: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearCoverNoteFilters()
  },
  methods: {
    closeDialog() {
      this.filtersCoverNote.coverNoteNo = ''
      this.$emit('close')
    },
    doClearCoverNoteFilters() {
      this.filtersCoverNote.coverNoteNo = ''
      this.filtersCoverNote.multiFundSfxCurr = this.multiFundSfxCurr
      this.filtersCoverNote.accountNo = this.accountNo
      this.filtersCoverNote.fund = this.fund
      this.filtersCoverNote.acctNoSfx = this.acctNoSfx
      this.filtersCoverNote.curr = this.curr
      this.fetchCoverNoteData()
    },
    doCoverNoteFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryCNFilterForm').then((result) => {
        if (result) {
          this.paginationCoverNote.page = 1
          this.filtersCoverNote.multiFundSfxCurr = this.multiFundSfxCurr
          this.filtersCoverNote.accountNo = this.accountNo
          this.filtersCoverNote.fund = this.fund
          this.filtersCoverNote.acctNoSfx = this.acctNoSfx
          this.filtersCoverNote.curr = this.curr
          this.fetchCoverNoteData()
        }
      })
    },
    assignCoverNote(data) {
      this.$emit('assign-cover-note-info', data)
      this.$emit('close')
    }
  },
  watch: {
    'paginationCoverNote': function (value) {
      this.fetchCoverNoteData()
    },
    boolRefresh: function (value) {
      if (value) {
        this.doClearCoverNoteFilters()
      }
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    callerPage: {
      type: String,
      default: ''
    },
    accountNo: {
      type: String,
      default: ''
    },
    multiFundSfxCurr: {
      type: Boolean,
      default: false
    },
    fund: {
      type: String,
      default: ''
    },
    acctNoSfx: {
      type: String,
      default: ''
    },
    curr: {
      type: String,
      default: ''
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
